var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "00-Elements-/-Icons-/Social/facebook",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.08064515,10.0645161 L8.08064515,17.2258065 C8.08064515,17.3225807 8.16129031,17.4193549 8.27419354,17.4193549 L10.9354839,17.4193549 C11.0322581,17.4193549 11.1290323,17.3387097 11.1290323,17.2258065 L11.1290323,9.93548387 L13.0483871,9.93548387 C13.1451613,9.93548387 13.2258065,9.85483871 13.2419355,9.75806451 L13.4032258,7.58064515 C13.4193549,7.46774192 13.3225807,7.37096773 13.2096774,7.37096773 L11.1129032,7.37096773 L11.1129032,5.82258062 C11.1129032,5.45161288 11.4032258,5.1612903 11.7741936,5.1612903 L13.2580645,5.1612903 C13.3548387,5.1612903 13.4516129,5.08064514 13.4516129,4.96774191 L13.4516129,2.79032254 C13.4516129,2.69354835 13.3709678,2.59677416 13.2580645,2.59677416 L10.7419355,2.59677416 C9.27419354,2.59677416 8.08064515,3.79032255 8.08064515,5.25806449 L8.08064515,7.37096773 L6.7580645,7.37096773 C6.66129031,7.37096773 6.56451611,7.45161289 6.56451611,7.56451612 L6.56451611,9.75806451 C6.56451611,9.85483871 6.64516127,9.9516129 6.7580645,9.9516129 L8.08064515,9.9516129 L8.08064515,10.0645161 Z",
  id: "facebook-1722382-1466168"
}));

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e4560dde.svg";
export { ForwardRef as ReactComponent };